import React from 'react';
import './Loader.css';

const Loader = ({ message = 'Loading...' }) => {
  return (
    <div className="loader-container">
      <div className="loader-gif-wrap">
        <img src="/assets/gifs/loading.gif" alt="Loading" className="loader-gif" />
      </div>
      <div className="time-loader">
        <div className="clock-face">
          <div className="clock-hand hour"></div>
          <div className="clock-hand minute"></div>
          <div className="clock-center"></div>
        </div>
        <div className="clock-ring ring-1"></div>
        <div className="clock-ring ring-2"></div>
        <div className="clock-ring ring-3"></div>
      </div>
      <p className="loader-message">{message}</p>
    </div>
  );
};

export default Loader;
